import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {StartScreenView} from '@fantasmagames/slot/src/modules/startscreen/StartScreenView';
import {StartScreenViewEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenViewEvents';

/**
 * module for start/intro screen
 * handles also keyboard input over start/intro screen
 */
export class StartScreenModule extends Module<StartScreenView> {
	protected _inputFunction: EventListenerObject;

	public afterInit(): void {
		super.afterInit();

		this.tryToInitiateStartScreen();
	}

	public restore(): void {
		super.restore();

		this.view.hide();
		this.onExitFinished();
	}

	protected setupStates(): void {}

	protected enterFirstState(): void {}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.STARTSCREEN_VIEW_MOBILE);
		} else {
			this.setView(Views.STARTSCREEN_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onViewEmitEvent(StartScreenViewEvents.INTRO_FINISHED, StartScreenEvents.INTRO_FINISHED);
		this.onViewEmitEvent(StartScreenViewEvents.INTRO_STARTED, StartScreenEvents.INTRO_STARTED);
		this.onViewEmitEvent(StartScreenViewEvents.INTRO_IDLE, StartScreenEvents.INTRO_IDLE);
		this.onViewEmitEvent(StartScreenViewEvents.EXIT_STARTED, StartScreenEvents.EXIT_STARTED);
		this.onViewEmitEvent(StartScreenView.PLAY_BUTTON_CLICKED, StartScreenEvents.PLAY_BUTTON_CLICKED);
		this.onView(StartScreenViewEvents.EXIT_FINISHED, this.onExitFinished);
	}

	protected tryToInitiateStartScreen(): void {
		if (this.logic.skipIntro === false && this.logic.hasRestore === false) {
			this.view.playIntroAnimation();
			this.addKeyboardInput();
		} else {
			this.onExitFinished();
		}
	}

	protected onExitFinished(): void {
		this.removeKeyboardInput();
		this.view.hide();
		this.eventManager.emit(StartScreenEvents.EXIT_FINISHED);
	}

	protected keyboardInput(event: KeyboardEvent): void {
		if (event.code === 'Space' || event.code === 'Enter') {
			this.view.proceed();
		}

		if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
			this.view.previousFeature();
		}

		if (event.code === 'KeyD' || event.code === 'ArrowRight') {
			this.view.nextFeature();
		}
	}

	protected addKeyboardInput(): void {
		if (!this.device.isMobile && !this.logic.skipIntro) {
			this._inputFunction = this.keyboardInput.bind(this);
			document.addEventListener('keydown', this._inputFunction);
		}
	}

	protected removeKeyboardInput(): void {
		document.removeEventListener('keydown', this._inputFunction);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/startscreen/StartScreenModule.ts